export default "__VITE_ASSET__ddfd8eef__"